




















































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { blackListTableColumns } from '../config/colums'
import {
  getTypeOneList,
  getBlackList,
  addBlackList,
  deleteResource,
  operatedList
} from '../../../service/search'
import { addWatermarker } from '../../../utils/renderWatermarker'
import { USER_NAME } from '../../../service/constant'

@Component
export default class BlackList extends Vue {
  public resourceId: string = ''
  public resourceName: string = ''
  public reId: string = '' //弹框内资源Id
  public typeOneData: any = []
  public modalTypeOneData: any = []
  public typeOne: string = '' // 一级品类
  public modalTypeOne: string = '' //弹框内一级品类
  public pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    showTotal: (total) => `共${total}条`
  }
  public showBlackListModal: boolean = false
  public showOperateRecordModal: boolean = false
  public showDeleteModal: boolean = false
  public operateRecordData: any = []
  public deleteResourceData: any = {}
  public blackListTableColumns: any[] = blackListTableColumns
  public dataSource: any[] = []
  get userName() {
    return this.$store.state[USER_NAME]
  }
  renderWaterMarker() {
    addWatermarker(document.querySelector('.black-list-content'), `17题库 ${this.userName}`)
  }
  handleChange(val) {
    this.typeOne = val
  }
  handleCategoryChange(value) {
    this.modalTypeOne = value
  }
  //切换页
  changePage(pagination) {
    this.pagination.current = pagination.current
    this.getBlackList(pagination.current)
  }
  // 搜索列表
  async getBlackList(page) {
    const options = {
      resourceId: this.resourceId,
      resourceName: this.resourceName,
      typeOne: this.typeOne,
      page,
      pageSize: this.pagination.pageSize
    }
    const { success, msg, data } = await getBlackList(options)
    if (success) {
      this.dataSource = data.records
      this.pagination.total = data.total
    }
  }
  //移除
  deleteResource(record) {
    this.deleteResourceData = record
    this.showDeleteModal = true
  }
  // 操作记录
  async operateRecord(record) {
    const options = {
      textId: record.id
    }
    const { success, msg, data } = await operatedList(options)
    if (success) {
      this.operateRecordData = data
      this.showOperateRecordModal = true
    }
  }
  // 显示黑名单弹框
  showBlackList() {
    this.reId = ''
    this.modalTypeOne = ''
    this.showBlackListModal = true
  }
  // 确定添加资源至黑名单
  async handleModalOk() {
    const options = {
      resourceId: this.reId,
      typeOne: this.modalTypeOne
    }
    const { success, msg } = await addBlackList(options)
    if (success) {
      this.$message.success(msg)
      const pagination = {
        current: 1
      }
      this.changePage(pagination)
      this.showBlackListModal = false
    }
  }
  handleModalCancel() {
    this.showBlackListModal = false
  }
  handleOperateModalCancel() {
    this.showOperateRecordModal = false
  }
  // 确定删除
  async handleDeleteModalOk() {
    const options = {
      textId: this.deleteResourceData.id
    }
    const { success, msg } = await deleteResource(options)
    if (success) {
      this.$message.success(msg)
      this.dataSource.splice(this.deleteResourceData.index - 1, 1)
      if (this.dataSource.length == 1 && this.pagination.current > 1) {
        this.getBlackList(this.pagination.current - 1)
      } else {
        this.getBlackList(this.pagination.current)
      }
      this.showDeleteModal = false
    }
  }
  handleDeleteModalCancel() {
    this.showDeleteModal = false
  }
  // 获取一级资源列表
  async getTypeOneList() {
    const { success, msg, data } = await getTypeOneList({})
    const typeData = JSON.parse(JSON.stringify(data))
    this.modalTypeOneData = typeData
    this.typeOneData = data
    this.typeOneData.unshift(['', '不限'])
  }
  mounted() {
    this.renderWaterMarker()
    this.getTypeOneList()
    this.getBlackList(1)
  }
}
